<template>
    <div class="export-services">
        <Header title="咨询详情"></Header>
        <div class="main-containe">
            <div class="title">产品信息</div>
            <van-cell-group>
                <van-field readonly label="标题：" v-model="servicesDetail.srvTitle" />
                <van-field readonly label="产品名称：" v-model="servicesDetail.productName" />
                <van-field readonly label="订单号：" v-model="servicesDetail.exceptExtraModel.orderCode" />
                <van-field readonly label="交货单编号：" v-model="servicesDetail.exceptExtraModel.deliveryOrderCode" />
                <van-field readonly label="生产企业：" v-model="servicesDetail.exceptExtraModel.productionEnterprise" />
                <van-field readonly label="物料编码：" v-model="servicesDetail.exceptExtraModel.materialCode" />
                <van-field readonly label="产品等级：" v-model="servicesDetail.exceptExtraModel.productLevel" />
                <van-field readonly label="产品品名：" v-model="servicesDetail.exceptExtraModel.productTradeName" />
                <van-field readonly label="产品批次：" v-model="servicesDetail.ProductBatch" />
            </van-cell-group>
            <div class="title">产品描述</div>
            <van-cell-group>
                <van-field readonly label="问题描述：" v-model="servicesDetail.applyDesc"></van-field>
            </van-cell-group>
            <van-cell-group>
            </van-cell-group>
            <div class="title">申请信息</div>
            <van-cell-group>
                <van-field readonly label="销售公司：" v-model="servicesDetail.orgName" />
                <van-field readonly label="专家编号：" v-model="servicesDetail.expertCode" />
                <van-field readonly label="专家姓名：" v-model="servicesDetail.expertName" />
                <van-field readonly label="公司名称：" v-model="servicesDetail.companyName" />
                <van-field readonly label="联系电话：" v-model="servicesDetail.contactorMobile" />
                <van-field readonly label="联系邮箱：" v-model="servicesDetail.contactorEmail" />
            </van-cell-group>
            <div class="title">附件</div>
            <van-cell-group>
                <van-field readonly label="附件：" v-model="servicesDetail.applyPicName" />
            </van-cell-group>
            <div class="title">处理</div>
            <van-cell-group>
                <van-field readonly label="处理时间：" v-model="servicesDetail.operateTime" />
                <van-field readonly label="处理意见：" v-model="servicesDetail.operateResult" />
                <van-field readonly label="参考文档：" v-model="servicesDetail.srvTitle" />
            </van-cell-group>
        </div>
    </div>
</template>
<script>
    import Header from "@/components/Header";
    import transactionApi from "@/request/transactionApi";
    export default {
        name: "expert-services-detail",
        components: {
            Header
        },
        mounted() {
            this.getDetil()
        },
        data() {
            return {
                servicesDetail: {}
            }
        },
        methods: {
            getDetil() {
                let params = {
                    expertSrvId: this.$route.query.id
                }
                transactionApi.getExpertConsultDetail(params).then((res) => {
                    console.log(res)
                    res.result.operateTime = this.$utils.formatDateTime(res.result.operateTime)
                    this.servicesDetail = res.result
                })
            }
        }
    }

</script>
<style lang="stylus">
    .export-services {
        font-size: 28px;
        display: flex;
        flex-direction: column;
        height: 100%;

    }

    .main-containe {
        flex: 1;
        height: 85vh;
        position: absolute;
        padding: 0 20px;
        top: 0.88rem;
        left: 0;
        right: 0;
        overflow: auto;
    }

    .export-services .van-cell-group {
        background: #f6f4f5;
    }

    .export-services .van-field__label {
        width: 180px;
        font-size: 26px;
    }

    .complain-dropdown-menu .van-cell {
        line-height: 50px;
    }

    .export-services .van-cell--required::before {
        left: 20px;
    }

    .export-services .van-popup {
        max-width: 95%;
    }

    .complain-dropdown-menu .van-dropdown-menu__title {
        line-height: 50px;
    }

    .complain-dropdown-menu .van-dropdown-menu__bar {
        border: 1px solid #666;
        background: #F4F4F4;
        border-radius: 10px;
    }

    .complain-dropdown-menu .van-dropdown-menu__title::after {
        border: 10px solid;
        border-color: transparent transparent #dcdee0 #dcdee0;
        right: -20px;
        margin-top: -14px;
    }

    .export-services .order-code .van-cell.van-cell--clickable {
        padding: 0 30px 0 0;
        line-height: 50px;
        margin-top: 10px;
    }

    .export-services .order-code .van-cell__title.van-field__label {
        padding-left: 28px;
    }

    .export-services .order-code .van-cell__title {}

    .export-services .order-code .van-cell.van-field {
        padding: 20px 0 20px 0;
    }

    .export-services .van-cell-group .van-cell {
        line-height: 50px;
        padding: 20px 30px;
        margin-top: 10px;
    }

    .export-services .order-code .van-cell__right-icon {
        margin-left: 0.04rem;
        color: #969799;
        line-height: 50px;
        font-size: 30px;
        vertical-align: middle;
    }


    .export-services {
        .title {
            font-size: 30px;
            height: 50px;
            line-height: 50px;
            padding: 20px 30px;
        }

        .file {
            min-height: 200px;
            background: #fff;
            padding: 20px 30px;
        }

        .complain-dropdown-menu {
            background: #fff;
            line-height: 50px;
            // padding: 20px 30px;
            margin-top: 10px;

            label {
                display: inline-block;
                width: 180px;
                font-size: 26px;
                padding-left: 20px;
            }

            .van-dropdown-menu {
                display: inline-block;
                padding: 20px 30px 20px 0;
                line-height: 50px;
                vertical-align: middle;
                width: calc(100% - 250px);
            }
        }
    }

    .btn-order {
        position: absolute;
        bottom: 2px;
        width: 100%;
        background: #fff;

        span {
            text-align: center;
            display: inline-block;
            width: 35%;
        }

        .card-btn {
            text-align: center;
            height: 100px;
            line-height: 100px;

            .btn {
                width: 90%;
                height: 80px;
                text-align: center;
                background: linear-gradient(132deg, #EF9623 0%, #E12020 100%);
                color: #ffffff;
                font-size: 32px;
                border-radius: 40px;
            }
        }
    }

</style>
